var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-container animated fadeInUp"},[_c('div',{staticClass:"title"},[_vm._v(" 非遗数字化与多源信息融合福建省高校工程研究中心 ")]),_c('div',{staticClass:"intro-text",domProps:{"innerHTML":_vm._s(_vm.baseConfig.intro)}})])}
var staticRenderFns = []

export { render, staticRenderFns }